module.exports = __webpack_public_path__ + "img/tea.3fae7d1a.svg";